import { Button, PageContainer } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import './addOnsDefault.css';
import { CirclePlus } from 'lucide-react';
import { COMPANY_CONFIG } from '../../../constants/companyConfig';

const companyName = COMPANY_CONFIG.name?.toLowerCase();

// Choose display name dynamically
const displayCompanyName =
  companyName === 'interbel' || COMPANY_CONFIG.themeId === 257
    ? 'Interbel'
    : COMPANY_CONFIG.name || 'Your Provider';

const addOns = [
  {
    id: 1,
    title: 'WI-FI Mesh Extender',
    price: '$3.95',
    priceUnit: '/month',
    image: '/images/items/mesh-extender.png',
    description: `Boost your home's Wi-Fi with ${displayCompanyName} Mesh Extender! Eliminate dead zones, enjoy high-speed internet everywhere. Sign up today and get 3 months free.`,
    finePrint:
      'After the 90-day period, a $3.95 charge will be added to your monthly billing. Other restrictions may apply.',
  },
];

const AddOnsDefault = () => {
  return (
    <PageContainer className="addOnsNode-Container">
      <h2 className="addOnsNode-Title">Internet Add-Ons</h2>
      <p className="addOnsNode-Subtitle">
        Enhance your plan with extra features and services designed to give you
        even more.
      </p>

      <div className="addOnsNode-Grid">
        {addOns.map((item) => (
          <div key={item.id} className="addOnsNode-AddonCard">
            <div className="addOnsNode-AddonImageWrapper">
              <img
                src={item.image}
                alt={item.title}
                className="addOnsNode-AddonImage"
              />
            </div>
            <div className="addOnsNode-AddonContent">
              <div className="addOnsNode-AddonTitle">{item.title}</div>
              <div className="addOnsNode-AddonPrice">
                <span className="addOnsNode-AddonPriceBold">{item.price}</span>
                <span className="addOnsNode-AddonPriceUnit">
                  {item.priceUnit}
                </span>
              </div>
              <p className="addOnsNode-AddonDescription">{item.description}</p>
              <p className="addOnsNode-AddonFinePrint">{item.finePrint}</p>
              <Button
                label="Add"
                variant="secondary"
                right={<CirclePlus />}
                fullWidth
              />
            </div>
          </div>
        ))}
      </div>

      <div className="addOnsNode-buttonRow">
        <Button
          customId={ELEMENT_IDS.PREVIOUS_STEP_BUTTON}
          label="Back"
          variant="secondary"
        />
        <Button customId={ELEMENT_IDS.NEXT_STEP_BUTTON} label="Next" />
      </div>
    </PageContainer>
  );
};

export default AddOnsDefault;
